import {
    conferenceSessionStorage,
    createUtcMoment,
    generateRandomString,
} from "conference/tools";
import { Duration } from "moment";
import { defaultMeetingPageSettings, MeetingPageSettings } from "./types";
import { createSettingsStoreContext, createStorageStore } from "@dvrt/react-tools";

const datetimeFormat = "YYYY-MM-DD HH:mm";

export const formatDateTime = (value: string) => {
    return createUtcMoment(value).local().format(datetimeFormat);
};

export const meetingPageSettingsStorage = createStorageStore(
    window.sessionStorage,
    "dvrt:conference:meetingPageSettings",
    defaultMeetingPageSettings,
    { migration: { legacyObjectKeys: ["meetingPageSettings"] } },
);

export type MeetingMediaPreferences = {
    audio: boolean;
    video: boolean;
};

// Keep pre-join media choices across meetings; they are loaded as defaults before joining.
export const meetingMediaPreferencesStorage = createStorageStore<MeetingMediaPreferences>(
    window.localStorage,
    "dvrt:conference:meetingMediaPreferences",
    { audio: true, video: true },
);

export const {
    SettingsStoreProvider: MeetingPageSettingsProvider,
    useSettings,
} = createSettingsStoreContext<MeetingPageSettings>();

export function getClientIdentifier(): string {
    const { clientIdentifier } = conferenceSessionStorage.getSnapshot();
    if (clientIdentifier) return clientIdentifier;

    const generatedIdentifier = generateRandomString(10);
    conferenceSessionStorage.update({ clientIdentifier: generatedIdentifier });
    return generatedIdentifier;
}

export const clientIdParamName = "client-id";

export const zeroPad = (num: number, places: number) => String(num).padStart(places, "0");

export const formatDuration = (d: Duration) => `${zeroPad(d.hours(), 2)}:${zeroPad(d.minutes(), 2)}:${zeroPad(d.seconds(), 2)}`;
